import * as Yup from 'yup'

import required from '@galo-monitor/forms/validators/required.validator'

const cultureSchema = ({ t }) => Yup.object().shape({
  name: required({ t })(Yup.string()),
  countries: required({
    t,
    isNotText: true
  })(Yup.array().of(Yup.string()).nullable()),
  creations: Yup.array().of(
    Yup.object().shape({
      name: required({ t })(Yup.string())
    })
  ),
  color: required({ t })(Yup.string())
})


export default cultureSchema
